import { render } from "./ContactoShow.vue?vue&type=template&id=a2296618"
import script from "./ContactoShow.vue?vue&type=script&lang=js"
export * from "./ContactoShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__